import { CaseTreeNode } from './cases.state'

export const findNodeById = <T extends { children: T[] | null; id: number }>(
    nodeId: number,
    nodes: T[]
): T | undefined => {
    let node: T | undefined = undefined
    const findNodeRecursive = (nodesInner: T[]): void => {
        for (let i = 0; !node && i < nodesInner.length; i++) {
            if (nodesInner[i].id === nodeId) {
                node = nodesInner[i]
                break
            }

            const children = nodesInner[i].children
            if (children) {
                findNodeRecursive(children)
            }
        }
    }
    findNodeRecursive(nodes)
    return node
}

export const removeNodeById = (nodeId: number, nodes: CaseTreeNode[]): CaseTreeNode[] => {
    return nodes
        .filter(n => n.id !== nodeId)
        .map(n => ({
            ...n,
            children: n.children ? removeNodeById(nodeId, n.children) : null,
        }))
}

export const moveNodeToParent = (
    nodeId: number,
    parentId: number | null,
    nodes: CaseTreeNode[]
): CaseTreeNode[] => {
    const node = findNodeById(nodeId, nodes)
    if (!node) return nodes

    nodes = removeNodeById(nodeId, nodes)

    if (parentId === null) {
        return [...nodes, node]
    }

    findNodeById(parentId, nodes)?.children?.push({ ...node, parent_id: parentId })

    return nodes
}
